<template>
  <div class="chat-billing-continue">
    <p
      v-if="description"
      class="text-body-2 mb-3"
    >
      {{ description }}
    </p>
    <v-btn
      color="primary"
      rounded="lg"
      :disabled="busy"
      :loading="busy"
      @click="onContinue"
    >
      {{ t('onboarding.wizard.data-entry.continue-to-billing') }}
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps<{
  description?: string
  busy?: boolean
}>()

const emit = defineEmits<{
  confirm: []
}>()

const { t } = useI18n()

const onContinue = () => {
  emit('confirm')
}
</script>
